import { Ds } from "@accurx/design";

export const PageTitle = ({ title }: { title: string }) => (
    <Ds.Text as="h1" size="large" weight="bold">
        {title}
    </Ds.Text>
);
